import _ from 'lodash';
import {createTheme, ThemeOptions} from '@mui/material/styles';
import {useEffect} from 'react';
import components from './Components';
import typography from './Typography';
import * as locales from '@mui/material/locale';
import appStyles from "../constants/appStyles";

export const BuildTheme = (config: any = {}) => {

    const themeOptions: ThemeOptions = {
        palette: {
            primary: {
                main: '#141',
                light: '#dcedc8',
                dark: '#003300',
                contrastText: '#fff',
            },
            secondary: {
                main: '#e65100',
                light: '#ffe0b2',
                dark: '#b26500',
                contrastText: '#fff',
            },
            success: {
                main: '#2e7d32',
                light: '#e8f5e9',
                dark: '#1b5e20',
                contrastText: '#fff',
            },
            error: {
                main: '#d32f2f',
                light: '#ffebee',
                dark: '#c62828',
                contrastText: '#fff',
            },
            warning: {
                main: '#f58f12',
                light: '#fff3e0',
                dark: '#e65100',
                contrastText: '#fff',
            },
            info: {
                main: '#0288d1',
                light: '#e1f5fe',
                dark: '#01579b',
                contrastText: '#fff',
            },
            background: {
                default: '#fbf7f2',
                paper: '#ddd',
            },
            divider: 'rgba(0,0,0,0.12)',
        },
    };


    const baseMode = {
        shape: {
            borderRadius: 7,
        },
        typography: typography,
    };
    const theme = createTheme(
        _.merge({}, baseMode, locales, themeOptions, {
            direction: config.direction,
        }),
    );
    theme.components = components(theme);

    return theme;
};

const ThemeSettings = () => {
    const activeDir = appStyles.activeDir;
    const activeTheme = appStyles.activeTheme;
    const theme = BuildTheme({
        direction: activeDir,
        theme: activeTheme,
    });
    useEffect(() => {
        document.dir = activeDir;
    }, [activeDir]);

    return theme;
};

export {ThemeSettings};
